import { useSelector } from 'react-redux';

export const useUpgradeModalShow = () => {
  const { show } = useSelector((state) => state?.plans?.upgradeModal);
  return show;
};
